module.exports = "<ul class=\"nav nav-tabs\">\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\"^.detail\" ng-bind=\"object.title || 'Product'\"></a>\n    </li>\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\"^.logs\">Logs</a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\"><div ui-view></div></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/product/templates/detail.section.html
// module id = 755
// module chunks = 0